import React from 'react';

const Minus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14.288" height="2.847" viewBox="0 0 14.288 2.847">
    <path id="e87f" d="M19.144,13.423H4.856V10.577H19.144Z" transform="translate(-4.856 -10.577)" fill="#231f20" />
  </svg>
);

export default Minus;
